/**
 * Scrolls root element to target element position.
 *
 * @param id - target element id
 * @param rootElementId - scroll container
 */
export const scrollToElementId = (id, rootElementId = undefined) => {

    if (id !== null && id !== undefined) {

        const element = document.getElementById(id);
        if (element) {
            const y = element.getBoundingClientRect().top + window.scrollY;

            const root = rootElementId ? document.getElementById(rootElementId) || window : window;
            root.scroll({top: y, behavior: 'smooth'});
        }
        else {
            console.warn('[scrollToElementId] Element not found by id:', id);
        }
    }
}

export const scrollToTop = () => {
    window.scroll({top: 0, behavior: 'smooth'});
}

export const sanitizeText = (rawText) => {

    if (!rawText) {
        return;
    }

    const sanitizerEl = document.createElement('div');
    sanitizerEl.innerHTML = rawText;
    return sanitizerEl.textContent;
}

export const blurBackground = () => {

    if (document.getElementsByTagName('main')[0]) {
        document.getElementsByTagName('main')[0].classList.add('blurred-layer');
    }

    if (document.getElementsByTagName('header')[0]) {
        document.getElementsByTagName('header')[0].classList.add('blurred-layer');
    }

    if (document.getElementsByTagName('footer')[0]) {
        document.getElementsByTagName('footer')[0].classList.add('blurred-layer');
    }
}

export const unblurBackground = () => {

    if (document.getElementsByTagName('main')[0]) {
        document.getElementsByTagName('main')[0].classList.remove('blurred-layer');
    }

    if (document.getElementsByTagName('header')[0]) {
        document.getElementsByTagName('header')[0].classList.remove('blurred-layer');
    }

    if (document.getElementsByTagName('footer')[0]) {
        document.getElementsByTagName('footer')[0].classList.remove('blurred-layer');
    }
}
